module.exports = __webpack_public_path__ + "static/sectionbefore-414a2cb23f7bb57a422f3db44934ce97.png";